// Gedeelde weergavelogica voor Stripe-abonnementsprijzen. Gebruikt door zowel
// het feestlocatie-lidmaatschap (Membership) als de dienst-onboarding, zodat
// de plan-labels en /maand-berekening op één plek staan.
//
// divider = deler om van het factuurbedrag naar een prijs-per-maand te komen:
//   maandelijks -> 1, half-jaarlijks -> 6, jaarlijks -> 12.
export function planMeta(price) {
  if (price.interval === "year") {
    return { title: "Voordeligst", period: "Elk jaar opzegbaar", divider: 12, popular: false };
  }
  if (price.interval === "month" && price.interval_count === 6) {
    return { title: "Balans", period: "Elke 6 maanden opzegbaar", divider: 6, popular: true };
  }
  return { title: "Flexibel", period: "Elke maand opzegbaar", divider: 1, popular: false };
}

// Prijs per maand als string. `decimals` bepaalt of er centen worden getoond
// (dienst toont €15,00 / €12,50; feestlocatie toont hele euro's).
export function euroPerMonth(price, decimals = 2) {
  const { divider } = planMeta(price);
  return (price.unit_amount / 100 / divider).toFixed(decimals).replace(".", ",");
}
